import { Button } from '@mui/material';
import { ISellOldAC } from '../../../utils/entities/interface';
import { capitalizeWords, formatDate } from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { ListTable } from '../../molecules/ListTable';
import moment from 'moment';

export const SellOldACList = ({
  technicians,
  isLoading,
  onUpdate,
  headerCells,
}: {
  technicians: ISellOldAC[];
  headerCells: [string, number][];
  isLoading: boolean;
  onUpdate: () => void;
}) => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      onClick: (item: ISellOldAC) =>
        navigate(`/request/detail`, { state: item?._id }),
    },
  ];

  return (
    <>
      <ListTable
        headerCells={headerCells}
        rows={technicians}
        isLoading={isLoading}
        actions={actions}
        renderCell={(technician: ISellOldAC, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return capitalizeWords(technician.enquiryId) || 'N/A';
            case 1:
              return capitalizeWords(technician.user.name) || 'N/A';
            case 2:
              return technician.subType || 'N/A';
            case 3:
              return technician.technicianName || 'N/A';
            case 4:
              return technician.user.phoneNumber || 'N/A';
            case 5:
              return (
                <div className="flex flex-col">
                  <span className="">
                    {technician.schedule.slot == 'SECOND_HALF'
                      ? '2nd Half'
                      : '1st Half'}
                  </span>
                  <span className="">
                    {moment(technician.schedule.date).format('DD/MM/yyyy')}
                  </span>
                </div>
              );
            case 6:
              return (
                technician.status.charAt(0).toUpperCase() +
                technician.status.slice(1).toLowerCase()
              );

            default:
              return null;
          }
        }}
      />
    </>
  );
};
